<a
  (document:mouseup)="close()"
  placement="bottom"
  triggers="manual"
  container="body"
  (mouseup)="$event.stopPropagation(); toggle()"
  [ngbPopover]="canEditNotificationList ?
    workflowNotificationListDropdownTemplate :
    memberNotificationToggleTemplate"
  popoverClass="workflow-notification-popover position-end"
  #notificationListPopover="ngbPopover"
  class="workflow-notification-toggle btn btn-sm"
  [class.button-link]="model.length > 0"
  [placement]="placement"
>
  <i class="cc-icon cc-icon-bell"></i>
</a>

<ng-template #workflowNotificationListDropdownTemplate>
  <div (mouseup)="$event.stopPropagation()" class="popover-container">
    <div class="sm-mb-2" i18n>
      Select who should be notified by email when a form enters this workflow column:
    </div>
    <div class="form-group notification-list-selector" *ngIf="canEditNotificationList">
      <cc-search-and-select
        name="workflow-notification-list"
        customClass="multiple-line"
        [items]="allOptions"
        [selected]="model"
        [multiple]="true"
        [clearable]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        (change)="onChangeOption($event)"
      >
        <ng-template #customOptionTemplate let-option>
          <ng-container
            [ngTemplateOutlet]="option.type !== 'divider' ? userOptionTemplate : dividerOptionTemplate"
            [ngTemplateOutletContext]="{ $implicit: option }"
          >
          </ng-container>
        </ng-template>
      </cc-search-and-select>
    </div>
  </div>
</ng-template>

<ng-template #dividerOptionTemplate let-notificationOption>
  <span class="divider divider-text">{{ notificationOption.label }}</span>
</ng-template>

<ng-template #userOptionTemplate let-notificationOption>
  <cc-popover
    *ngIf="notificationOption.hasPopover"
    container="body"
    popoverCustomClass="popover-arrow-top-aligned workflow-notification-list-option-popover"
  >
    <span content i18n>{{ notificationOption.popoverLabel }}</span>

    <div trigger class="sm-flex sm-items-center">
      <i *ngIf="notificationOption.icon" class="cc-icon {{ notificationOption.icon }} sm-mr-1"></i>
      <cc-user-avatar
        *ngIf="!notificationOption.icon"
        [user]="notificationOption"
        class="sm-mr-1 small-avatar"
      ></cc-user-avatar>
      <span class="sm-overflow-hidden sm-text-ellipsis">{{ notificationOption.label }}</span>
      <span *ngIf="notificationOption.value === currentUser.email" class="current-user-label">(You)</span>
    </div>
  </cc-popover>

  <div *ngIf="!notificationOption.hasPopover" class="sm-flex sm-items-center">
    <i *ngIf="notificationOption.icon" class="cc-icon {{ notificationOption.icon }} sm-mr-1"></i>
    <cc-user-avatar
      *ngIf="!notificationOption.icon"
      [user]="notificationOption"
      class="sm-mr-1 small-avatar"
    ></cc-user-avatar>
    <span class="sm-overflow-hidden sm-text-ellipsis">{{ notificationOption.label }}</span>
    <span *ngIf="notificationOption.value === currentUser.email" class="current-user-label">(You)</span>
  </div>
</ng-template>

<ng-template #memberNotificationToggleTemplate>
  <div (mouseup)="$event.stopPropagation()" class="popover-container">
    <div class="sm-flex sm-flex-col sm-gap-2" i18n>
      <div class="notification-toggle-container">
        <div class="sm-text-xs sm-self-center">Turn on notifications for this column: </div>
        <label
          class="toggle-control"
        >
          <input
            name="input-toggle"
            type="checkbox"
            [ngModel]="currentUserInList"
            (click)="$event.preventDefault(); toggleCurrentUserNotification()"
          />
          <span class="control"></span>
        </label>
      </div>
      <div class="sm-text-xs">People who will be notified when a form enters this workflow column:</div>
      <div class="sm-flex sm-gap-1 sm-flex-wrap">
        <ng-container *ngFor="let user of notificationList" class="option {{ user.notifyRole ? 'sm-capitalize' : '' }}">
          <div data-test="notified-user" class="option {{ user.notifyRole ? 'sm-capitalize' : '' }}">
            <i *ngIf="user.notifyRole" class="cc-icon cc-icon-zap"></i>
            <cc-user-avatar
              *ngIf="!user.notifyRole && user.isActivated"
              [user]="user"
              [size]="24"
            ></cc-user-avatar>
            {{ user.fullName ?? user.notifyRole }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>